import React from 'react';
import PropTypes from 'prop-types';
import { FaTimesCircle } from 'react-icons/fa';
import { CriteriaDiv, ContainerCrt } from './criteria.css';

const Criteria = ({ textExc, textInc, hideModal }) => {
  const normalizeText = (value) => (typeof value === 'string' ? value.trim() : '');
  const normalizedInc = normalizeText(textInc);
  const normalizedExc = normalizeText(textExc);
  const hasBothCriteria = Boolean(normalizedInc) && Boolean(normalizedExc);
  const fallbackText = normalizedInc || normalizedExc;

  return (
    <ContainerCrt>
      <FaTimesCircle onClick={hideModal} />
      <CriteriaDiv>
        {hasBothCriteria ? (
          <>
            <h2>{'Inclusion Criteria'}</h2>
            <pre>{normalizedInc}</pre>

            <h2 className={'exclusion'}>{'Exclusion Criteria'}</h2>
            <pre>{normalizedExc}</pre>
          </>
        ) : (
          <>
            <h2>{'Eligibility Criteria'}</h2>
            {fallbackText ? (
              <pre>{fallbackText}</pre>
            ) : (
              <pre>{'Sorry there is no Eligibility Criteria'}</pre>
            )}
          </>
        )}
      </CriteriaDiv>
    </ContainerCrt>
  );
};

Criteria.propTypes = {
  textInc: PropTypes.string,
  textExc: PropTypes.string,
  hideModal: PropTypes.any,
};

export default Criteria;
